export default {
  createZoomMeeting: '/zoom/createZoomMeeting',
  joinZoomMeeting: '/zoom/joinZoomMeeting',
  getrecordingLink: '/zoom/getrecordingLink'
}
